import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import api from '../utils/api';

export default function Profile() {
  const { user } = useAuth();
  const toast = useToast();

  const [nameForm, setNameForm]   = useState({ name: user?.name || '' });
  const [passForm, setPassForm]   = useState({ current: '', newPass: '', confirm: '' });
  const [nameLoading, setNL] = useState(false);
  const [passLoading, setPL] = useState(false);

  const initials = user?.name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || 'U';
  const since    = user?.createdAt ? new Date(user.createdAt).toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' }) : '—';

  const handleName = async e => {
    e.preventDefault();
    if (!nameForm.name.trim()) return;
    setNL(true);
    try {
      await api.put('/auth/profile', { name: nameForm.name });
      toast.success('Nom mis à jour avec succès.');
    } catch {
      toast.error('Erreur lors de la mise à jour.');
    } finally { setNL(false); }
  };

  const handlePass = async e => {
    e.preventDefault();
    if (passForm.newPass !== passForm.confirm) return toast.error('Les mots de passe ne correspondent pas.');
    if (passForm.newPass.length < 6) return toast.error('Minimum 6 caractères.');
    setPL(true);
    try {
      await api.put('/auth/password', { currentPassword: passForm.current, newPassword: passForm.newPass });
      toast.success('Mot de passe modifié avec succès.');
      setPassForm({ current: '', newPass: '', confirm: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Mot de passe actuel incorrect.');
    } finally { setPL(false); }
  };

  return (
    <div className="profile-page">
      {/* Header */}
      <div className="profile-header">
        <div className="profile-avatar-big">{initials}</div>
        <div>
          <div className="profile-name">{user?.name}</div>
          <div className="profile-since">Membre depuis le {since}</div>
          <div style={{ marginTop: '0.4rem' }}>
            <span className="badge badge-in-progress" style={{ fontSize: '0.72rem' }}>✅ Compte actif</span>
          </div>
        </div>
      </div>

      {/* Update name */}
      <div className="section-card">
        <div className="section-card-title">👤 Informations personnelles</div>
        <form onSubmit={handleName}>
          <div className="form-group">
            <label className="form-label">Nom complet</label>
            <input className="form-input" value={nameForm.name}
              onChange={e => setNameForm({ name: e.target.value })} placeholder="Votre nom" required />
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" value={user?.email} disabled
              style={{ opacity: 0.55, cursor: 'not-allowed' }} />
          </div>
          <button className="btn btn-primary btn-sm" type="submit" disabled={nameLoading} style={{ width: 'auto' }}>
            {nameLoading ? '⏳ Sauvegarde…' : '✓ Sauvegarder'}
          </button>
        </form>
      </div>

      {/* Change password */}
      <div className="section-card" style={{ animationDelay: '0.08s' }}>
        <div className="section-card-title">🔐 Changer le mot de passe</div>
        <form onSubmit={handlePass}>
          <div className="form-group">
            <label className="form-label">Mot de passe actuel</label>
            <input className="form-input" type="password" value={passForm.current}
              onChange={e => setPassForm(f => ({ ...f, current: e.target.value }))} placeholder="••••••••" required />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Nouveau mot de passe</label>
              <input className="form-input" type="password" value={passForm.newPass}
                onChange={e => setPassForm(f => ({ ...f, newPass: e.target.value }))} placeholder="Min. 6 caractères" required />
            </div>
            <div className="form-group">
              <label className="form-label">Confirmer</label>
              <input className="form-input" type="password" value={passForm.confirm}
                onChange={e => setPassForm(f => ({ ...f, confirm: e.target.value }))} placeholder="••••••••" required />
            </div>
          </div>
          <button className="btn btn-primary btn-sm" type="submit" disabled={passLoading} style={{ width: 'auto' }}>
            {passLoading ? '⏳ Mise à jour…' : '🔒 Changer le mot de passe'}
          </button>
        </form>
      </div>

      {/* Danger zone */}
      <div className="section-card" style={{ animationDelay: '0.14s', borderColor: 'rgba(248,113,113,0.2)' }}>
        <div className="section-card-title" style={{ color: 'var(--danger)' }}> Zone de danger</div>
        <p style={{ fontSize: '0.82rem', color: 'var(--text-secondary)', marginBottom: '1rem' }}>
          Ces actions sont irréversibles. Procédez avec précaution.
        </p>
        <button className="btn btn-danger-outline btn-sm"
          onClick={() => toast.warning('Fonctionnalité disponible prochainement.')}>
          🗑 Supprimer mon compte
        </button>
      </div>
    </div>
  );
}
